<template>
<div class="breadcrumb">

	<div class="container">
		<router-link
			v-if="to"
			:to="to"
			class="breadcrumb__link"
		>
			<img
				src="@/svg/hand-pointing-back.svg"
			/>
			<span>{{ label }}</span>
		</router-link>
		<a
			v-else
			href="#"
			@click.prevent="$router.go(-1)"
			class="breadcrumb__link"
		>
			<img
				src="@/svg/hand-pointing-back.svg"
			/>
			<span>{{ label }}</span>
		</a>
	</div>
</div>
</template>

<script>
// Styles
import '@/sass/components/_breadcrumb.scss';

export default {
	props: ['to', 'label']
};
</script>
